import React from "react";
import Playlist from "src/routes/Playlist";

const PlaylistPage = (props) => {
  return <Playlist {...props} data={props.pageContext.playlists} />;
};

export default PlaylistPage;
